import React, { useState, useEffect, useRef, useContext } from "react";

import { useHistory, useParams } from "react-router-dom";
import { parseISO, format, isSameDay } from "date-fns";
import clsx from "clsx";
import emojiRegex from "emoji-regex";
import { v4 as uuidv4 } from "uuid";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import { i18n } from "../../translate/i18n";
import CheckIcon from "@material-ui/icons/CheckCircle";
import ReplayIcon from "@material-ui/icons/Replay";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import api from "../../services/api";
import { Dialog, DialogContent } from "@material-ui/core";

import MarkdownWrapper from "../MarkdownWrapper";
import { Tooltip } from "@material-ui/core";
// import { Thermometer, Megaphone, Fire, Snowflake } from "@phosphor-icons/react";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";

import facebookIcon from "../../assets/facebook.png";
import insatagramIcon from "../../assets/instagram.png";
import whatsappIcon from "../../assets/whatsapp.png";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
    ticket: {
        position: "relative",
        padding: theme.spacing(1.5),
        //paddingBottom: 36, // Espaço para as tags na parte inferior
        background: theme.mode === "light" ? '#ffffff' : '#1e1e1e',
        borderRadius: 16,
        boxShadow: theme.mode === "light" ? '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)' : '0 4px 6px -1px rgba(0,0,0,0.3)',
        transition: 'all 0.2s ease-in-out',
        //marginBottom: theme.spacing(1.5),
        '&:hover': {
            boxShadow: theme.mode === "light" ? '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)' : '0 6px 8px -2px rgba(0,0,0,0.4)',
            transform: 'translateY(-1px)',
        },
        "&.Mui-selected": {
            backgroundColor: theme.mode === "light" ? "#f0f9ff" : "rgba(59, 130, 246, 0.1)",
            border: `1px solid ${theme.mode === "light" ? '#97A2BE' : '#333333'}`,
            boxShadow: `0 0 0 1px ${theme.palette.primary.main}40`,
            "&:hover": {
                backgroundColor: theme.mode === "light" ? "#e0f2fe" : "rgba(59, 130, 246, 0.15)",
            }
        },
        "& + li.MuiDivider-root": {
            display: "none"
        }
    },

    pendingTicket: {
        cursor: "unset",
    },

    noTicketsDiv: {
        display: "flex",
        height: "100px",
        margin: 40,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },

    noTicketsText: {
        textAlign: "center",
        color: "rgb(104, 121, 146)",
        fontSize: "14px",
        lineHeight: "1.4",
    },

    noTicketsTitle: {
        textAlign: "center",
        fontSize: "16px",
        fontWeight: "600",
        margin: "0px",
    },

    contactNameWrapper: {
        display: "flex",
        justifyContent: "space-between",
        "& > span": {
            fontSize: "15px",
            fontWeight: "bold",
            color: theme.mode === "light" ? "#0B141A" : "#ffffff",
        }
    },

    lastMessageTime: {
        position: "absolute",
        right: 16,
        top: 20,
        fontSize: "0.75rem",
        fontWeight: 500,
        color: theme.mode === "light" ? "#6b7280" : "#9ca3af",
    },

    closedBadge: {
        alignSelf: "center",
        justifySelf: "flex-end",
        marginRight: 32,
        marginLeft: "auto",
    },

    contactLastMessage: {
        paddingRight: 20,
        fontSize: "0.85rem",
        color: theme.mode === "light" ? "#2563eb" : "#60a5fa",
        opacity: 0.9,
        marginTop: 4,
        display: "block",
    },

    newMessagesCount: {
        position: "absolute",
        right: 24,
        top: 40,
    },

    bottomButton: {
        alignSelf: "center",
        backgroundColor: theme.mode === "light" ? "#ffffff" : "transparent",
        border: `1px solid ${theme.mode === "light" ? '#e5e7eb' : '#4b5563'}`,
        borderRadius: 10,
        padding: 6,
        margin: "20px 0 2px 0 !important",
        boxShadow: theme.mode === "light" ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
        "&:hover": {
            backgroundColor: theme.mode === "light" ? "#f9fafb" : "rgba(255, 255, 255, 0.05)",
            borderColor: theme.palette.primary.main,
            "& svg": {
                color: theme.palette.primary.main,
            }
        },
        "& svg": {
            fontSize: 20,
            color: theme.mode === "light" ? "#6b7280" : "#9ca3af",
        }
    },

    badgeStyle: {
        top: "-30px",
        right: "-16px",
        color: "white",
        backgroundColor: green[500],
        fontWeight: "bold",
    },

    acceptButton: {
        position: "absolute",
        left: "50%",
    },

    ticketQueueColor: {
        flex: "none",
        width: "8px",
        height: "100%",
        position: "absolute",
        top: "0%",
        left: "0%",
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
    },

    userTag: {
        position: "absolute",
        right: 12,
        bottom: 8,
        backgroundColor: theme.mode === "light" ? "#f3f4f6" : "#374151",
        color: theme.mode === "light" ? "#4b5563" : "#d1d5db",
        border: `1px solid ${theme.mode === "light" ? "#e5e7eb" : "#4b5563"}`,
        padding: "2px 8px",
        borderRadius: "6px",
        fontSize: "0.65rem",
        fontWeight: 600,
    },
    divTags: {
        position: "absolute",
        left: 72,
        bottom: 8,
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "6px",
    },
    tags: {
        color: "#FFF",
        border: "none",
        padding: "2px 8px",
        borderRadius: "6px",
        fontSize: "0.65rem",
        fontWeight: "bold",
        textAlign: "center",
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    },
    divUser: {
        position: "absolute",
        marginRight: 0,
        left: 0,
        top: 0,
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    user: {
        color: "#eee",
        border: "1px solid #CCC",
        padding: 0,
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: 0,
        fontSize: "0.6em",
        textAlign: "center",
    },

    placeholderBadge: {
        padding: "2px 6px",
        borderRadius: 6,
        fontSize: "0.65rem",
        fontWeight: "bold",
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        textTransform: 'uppercase',
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        border: "1px solid transparent",
    },
    scoreBadgeVeryHot: { backgroundColor: '#7f1d1d', color: '#ffffff', borderColor: '#450a0a' },
    scoreBadgeHot: { backgroundColor: '#fee2e2', color: '#dc2626', borderColor: '#fecaca' },
    scoreBadgeWarm: { backgroundColor: '#fef3c7', color: '#d97706', borderColor: '#fde68a' },
    scoreBadgeCold: { backgroundColor: '#e0f2fe', color: '#2563eb', borderColor: '#bae6fd' },
    scoreBadgeFrozen: { backgroundColor: '#f3f4f6', color: '#4b5563', borderColor: '#d1d5db' },
    adsBadge: { backgroundColor: '#f3e8ff', color: '#4f46e5', borderColor: '#e9d5ff' },

    tagsWrapper: {
        zIndex: 500,
    },

    badge: {
        backgroundColor: "#44b700",
        color: "#44b700",
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        "&::after": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            animation: "$ripple 1.2s infinite ease-in-out",
            border: "1px solid currentColor",
            content: '""',
        },
    },
    "@keyframes ripple": {
        "0%": {
            transform: "scale(.8)",
            opacity: 1,
        },
        "100%": {
            transform: "scale(2.4)",
            opacity: 0,
        },
    },

    // Estilos para o modal da imagem
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        width: 48,
        height: 48,
        "&:hover": {
            opacity: 0.8,
        },
    }
}));

const SmallAvatar = withStyles((theme) => ({
    root: {
        width: 20,
        height: 20,
        border: `2px solid ${theme.mode === "light" ? "#ffffff" : "#1e1e1e"}`,
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    },
}))(Avatar);

const getAvatarChannel = (channel) => {
    if (channel === "facebook") {
        return facebookIcon;
    }

    if (channel === "whatsapp") {
        return whatsappIcon;
    }

    if (channel === "whatsappapi") {
        return whatsappIcon;
    }

    if (channel === "instagram") {
        return insatagramIcon;
    }
};

const TicketListItem = ({ ticket, isNotification = false }) => {
    const classes = useStyles();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const { ticketId } = useParams();
    const isMounted = useRef(true);
    const { user } = useContext(AuthContext);
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
    const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem

    /* LEAD SCORING: Funcionalidade visual desativada
    // Hook de segurança: evita que a temperatura zere se o websocket atualizar o ticket sem o objeto scoringInfo
    const [localScoringInfo, setLocalScoringInfo] = useState(
        ticket?.scoringInfo || { leadScore: 0, temperatureStatus: 'cold', isFromAds: false, actionAlerts: {} }
    );

    useEffect(() => {
        if (ticket?.scoringInfo) {
            setLocalScoringInfo(ticket.scoringInfo);
        }
    }, [ticket?.scoringInfo]);
    */

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    if (!ticket || !ticket.id) return null;

    // Função para abrir modal da imagem
    const handleImageClick = (e) => {
        e.stopPropagation(); // Prevenir que o clique no avatar selecione o ticket
        if (ticket?.contact?.urlPicture) {
            setImageModalOpen(true);
        }
    };

    // Função para fechar modal da imagem
    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    function getRatingIcon(rate) {
        let icon = "";
        if (rate === 1) {
            icon = "😡";
        } else if (rate === 2) {
            icon = "😠";
        } else if (rate === 3) {
            icon = "😐";
        } else if (rate === 4) {
            icon = "😃";
        } else if (rate === 5) {
            icon = "😍";
        }

        return icon;
    }


    const handleAcepptTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "open",
                userId: user?.id,
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        history.push(`/tickets/${ticket.uuid}`);
    };

    const handleAcepptTicketBot = async (ticket) => {
        // alert("Bot");
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "open",
                userId: user?.id,
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        history.push(`/tickets/${ticket.uuid}`);
    };

    const handleReopenTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "open",
                userId: user?.id,
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        history.push(`/tickets/${ticket.uuid}`);
    };

    const handleViewTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "pending",
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        history.push(`/tickets/${ticket.uuid}`);
    };

    const handleSelectTicket = (ticket) => {
        const code = uuidv4();
        const { id, uuid } = ticket || {};
        setTabOpen(ticket?.status)
        setCurrentTicket({ id, uuid, code });
    };

    const handleClosedTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
    };

    const renderUserName = (name) => {
        let str = name.replace(emojiRegex(), "").trim();

        const firstName = str.split(" ")[0];

        return firstName;
    };

    //const scoringInfo = localScoringInfo;

    return (
        <React.Fragment key={ticket.id}>
            <ListItem
                dense
                button
                onClick={(e) => {
                    handleSelectTicket(ticket)
                }}
            selected={ticketId && +ticketId === ticket?.id}
                className={clsx(classes.ticket, {
                    [classes.pendingTicket]: ticket?.status === "pending",
                })}
            >
                <Tooltip
                    arrow
                    placement="right"
                    title={ticket?.queue?.name || "Sem departamento"}
                >
                    <span
                        style={{
                        backgroundColor: ticket?.queue?.color || "#7C7C7C",
                        }}
                        className={classes.ticketQueueColor}
                    ></span>
                </Tooltip>
                <ListItemAvatar>
                    <Badge
                        overlap="circular"
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        badgeContent={
                            <SmallAvatar
                                alt={ticket?.channel}
                                src={getAvatarChannel(ticket?.channel)}
                            />
                        }
                    >
                        <Avatar
                        alt={ticket?.contact?.name}
                        src={ticket?.contact?.urlPicture}
                            className={classes.clickableAvatar}
                            onClick={handleImageClick}
                        />
                    </Badge>
                </ListItemAvatar>
                <ListItemText
                    disableTypography
                    primary={
                        <span className={classes.contactNameWrapper}>
                            <Typography
                                noWrap
                                component="span"
                                variant="body2"
                                color="textPrimary"
                            >
                            {ticket?.contact?.name}
                            </Typography>

                            {/* {ticket.lastMessage && ( */}
                            <Typography
                                className={classes.lastMessageTime}
                                component="span"
                                variant="body2"
                                color="textSecondary"
                            >
                                {isSameDay(
                                parseISO(ticket?.updatedAt || new Date().toISOString()),
                                    new Date()
                                ) ? (
                                    <>
                                        {format(
                                        parseISO(ticket?.updatedAt || new Date().toISOString()),
                                            "HH:mm"
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {format(
                                        parseISO(ticket?.updatedAt || new Date().toISOString()),
                                            "dd/MM/yyyy"
                                        )}
                                    </>
                                )}
                            </Typography>
                            {/* )} */}
                            {ticket?.whatsappId && (
                                <div
                                    className={classes.userTag}
                                    title={i18n.t(
                                        "ticketsList.connectionTitle"
                                    )}
                                >
                                    {ticket?.whatsapp?.name}
                                </div>
                            )}
                        </span>
                    }
                    secondary={
                        <span className={classes.contactNameWrapper}>
                        {ticket?.status === "closed"
                                ? ticket?.userRating
                                    ? getRatingIcon(ticket?.userRating?.rate)
                                    : null
                                : null}
                            <Typography
                                className={classes.contactLastMessage}
                                noWrap
                                component="span"
                                variant="body2"
                                color="textSecondary"
                            >
                            {ticket?.lastMessage ? (
                                    <MarkdownWrapper>
                                    {ticket?.lastMessage}
                                    </MarkdownWrapper>
                                ) : (
                                    <br />
                                )}
                            </Typography>

                            <Badge
                                overlap="rectangular"
                                className={classes.newMessagesCount}
                            badgeContent={ticket?.unreadMessages}
                                classes={{
                                    badge: classes.badgeStyle,
                                }}
                            />
                        </span>
                    }
                />
            {ticket?.status === "pending" && (
                    <IconButton
                        className={classes.bottomButton}
                        color="primary"
                        loading={loading.toString()}
                        onClick={(e) =>
                        ticket?.isBot
                                ? handleAcepptTicketBot(ticket)
                                : handleAcepptTicket(ticket)
                        }
                    >
                        <CheckIcon />
                    </IconButton>
                )}
                {/* {ticket.status === "pending" && (
                    <IconButton
                        className={classes.bottomButton}
                        color="primary"
                        onClick={(e) => handleViewTicket(ticket)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                )} */}
				{!isNotification && (
					<div className={classes.divTags} style={{pointerEvents: "none"}}>
					{ticket?.isGroup && (
                        <div className={classes.tagsWrapper}>
                            <div
                            key={ticket?.id}
                                className={classes.tags}
                                // title={ticket.isGroup}
                                style={{
                                    backgroundColor: "#7C7C7C",
                                }}
                            >
                                Grupo
                            </div>
                        </div>
                    )}
                {ticket?.user?.id && ticket?.user?.name &&
                        user?.profile?.toUpperCase() === "ADMIN" && (
                            <div className={classes.tagsWrapper}>
                                <div
                                key={ticket?.user?.id}
                                    className={classes.tags}
                                title={renderUserName(ticket?.user?.name)}
                                    style={{
                                        backgroundColor:
                                        ticket?.user?.color === "" ||
                                            !ticket?.user?.color
                                                ? "#7C7C7C"
                                            : ticket?.user?.color,
                                    }}
                                >
                                {renderUserName(ticket?.user?.name)}
                                </div>
                            </div>
                        )}
                {ticket?.tags?.length > 0 && ticket?.tags[0] && (
                        <>
                            <div className={classes.tagsWrapper}>
                                <div
                                key={ticket?.tags[0]?.id}
                                    className={classes.tags}
                                title={ticket?.tags[0]?.name}
                                    style={{
                                    backgroundColor: ticket?.tags[0]?.color,
                                    }}
                                >
                                {ticket?.tags[0]?.name}
                                </div>
                            </div>
                        {ticket?.tags?.length > 1 && ticket?.tags[1] && (
                                <div
                                key={ticket?.tags[1]?.id}
                                    className={classes.tags}
                                title={ticket?.tags[1]?.name}
                                    style={{
                                    backgroundColor: ticket?.tags[1]?.color,
                                    }}
                                >
                                +{ticket?.tags?.length - 1}
                                </div>
                            )}
                        </>
                    )}
                    {/* LEAD SCORING: Badges de Temperatura e Origem desativadas visualmente
                    {scoringInfo.actionAlerts?.criticalCooldown ? (
                        <div className={classes.tagsWrapper}>
                            <Tooltip title="Esfriamento Crítico atingido (Lead Congelado)">
                                <div className={clsx(classes.placeholderBadge, classes.scoreBadgeFrozen)}>
                                    <Snowflake size={12} weight="bold" /> Base Fria
                                </div>
                            </Tooltip>
                        </div>
                    ) : (
                        <div className={classes.tagsWrapper}>
                            <Tooltip title={`Temperatura: ${scoringInfo.leadScore}/100`}>
                                <div className={clsx(classes.placeholderBadge, {
                                    [classes.scoreBadgeVeryHot]: scoringInfo.temperatureStatus === 'very_hot',
                                    [classes.scoreBadgeHot]: scoringInfo.temperatureStatus === 'hot',
                                    [classes.scoreBadgeWarm]: scoringInfo.temperatureStatus === 'warm',
                                    [classes.scoreBadgeCold]: scoringInfo.temperatureStatus === 'cold',
                                })}>
                                    {scoringInfo.temperatureStatus === 'very_hot' ? <Fire size={12} weight="bold" /> : <Thermometer size={12} weight="bold" />} {scoringInfo.leadScore}
                                </div>
                            </Tooltip>
                        </div>
                    )}
                    {scoringInfo.isFromAds && (
                        <div className={classes.tagsWrapper}>
                            <Tooltip title="Origem: Tráfego Pago (Ads)">
                                <div className={clsx(classes.placeholderBadge, classes.adsBadge)}>
                                    <Megaphone size={12} weight="bold" /> Ads
                                </div>
                            </Tooltip>
                        </div>
                    )}
                    */}
                    {/* {ticket?.contact?.contactWallets && ticket.contact.contactWallets.length > 0 && (
                        <div className={classes.tagsWrapper}>
                            <div
                                className={classes.tags}
                                title={`Carteira: ${ticket.contact.contactWallets[0].wallet?.name || 'N/A'}`}
                                style={{
                                    backgroundColor: "#FF6B35",
                                }}
                            >
                                📋 {ticket.contact.contactWallets[0].wallet?.name || 'N/A'}
                            </div>
                        </div>
                    )} */}
					</div>
				)}

                {(ticket.status === "pending" && (user?.showDashboard === "enabled" || user?.profile === "admin")) && (
                    <IconButton
                        className={classes.bottomButton}
                        color="primary"
                        onClick={(e) => handleClosedTicket(ticket)}
                    >
                        <ClearOutlinedIcon />
                    </IconButton>
                )}
                {ticket?.status === "open" && (
                    <IconButton
                        className={classes.bottomButton}
                        color="primary"
                        onClick={(e) => handleViewTicket(ticket)}
                    >
                        <ReplayIcon />
                    </IconButton>
                )}
                {ticket?.status === "open" && (
                    <IconButton
                        className={classes.bottomButton}
                        color="primary"
                        onClick={(e) => handleClosedTicket(ticket)}
                    >
                        <ClearOutlinedIcon />
                    </IconButton>
                )}
                {ticket?.status === "closed" && (
                    <IconButton
                        className={classes.bottomButton}
                        color="primary"
                        onClick={(e) => handleReopenTicket(ticket)}
                    >
                        <ReplayIcon />
                    </IconButton>
                )}
                {ticket?.status === "closed" && (
                    <IconButton
                        className={classes.bottomButton}
                        color="primary"
                    ></IconButton>
                )}
            </ListItem>
            <Divider variant="inset" component="li" />

            {/* Modal da Imagem */}
            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img 
                    src={ticket?.contact?.urlPicture} 
                    alt={ticket?.contact?.name || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketListItem;